import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthService } from '../auth-o3/shared/services/auth.service';
import {
  ApplicationTokenService,
  IApplicationToken,
} from '../auth-o3/shared/services/application-token.service';
import { GetErrorMessageFromResponse } from '../product-capture/utils/get-error-message-from-response';

@Component({
  selector: 'app-report-hub',
  templateUrl: './report-hub.component.html',
  styleUrls: ['./report-hub.component.scss'],
})
export class ReportHubComponent implements OnInit {
  idToken: any = null;
  accessToken: any = null;
  refreshToken: string = '';
  applicationName: string = '';
  applicationUrl: string = '';
  applicationId: string = '';
  applicationToken: IApplicationToken | null = null;
  applicationTokenMeta: {
    audience: string;
    expiresAt: string;
    expiresIn: number;
  } | null = null;
  applicationTokenLoading: boolean = false;
  applicationTokenError: string = '';
  applicationTokenVerified: boolean | null = null;
  applicationTokenVerifying: boolean = false;
  user: string = '';
  email: string = '';
  isAuthenticated: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private applicationTokenService: ApplicationTokenService
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      this.applicationName = params['name'] || 'Report Hub';
      this.applicationUrl = params['url'] || '';
      this.applicationId = params['applicationId'] || '';

      if (this.applicationId) {
        this.mintApplicationToken();
      }
    });

    this.authService.onUserSession.pipe(take(1)).subscribe((session) => {
      if (session?.isValid()) {
        this.isAuthenticated = true;
        this.user = session.idToken.payload['cognito:username'];
        this.email = session.idToken.payload.email;

        this.idToken = {
          raw: session.idToken.jwtToken,
          payload: session.idToken.payload,
        };

        this.accessToken = {
          raw: session.accessToken.jwtToken,
          payload: session.accessToken.payload,
        };

        this.refreshToken = 'Available in session';
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  async signOut() {
    this.isAuthenticated = false;
    this.user = '';
    this.email = '';

    await this.authService.signOut();
    this.router.navigate(['/login']);
  }

  private mintApplicationToken() {
    this.applicationTokenLoading = true;
    this.applicationTokenError = '';

    this.applicationTokenService
      .mintToken(this.applicationId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.applicationToken = this.applicationTokenService.decodeToken(
            response.token
          );
          this.applicationTokenMeta = {
            audience: response.audience,
            expiresAt: response.expiresAt,
            expiresIn: response.expiresIn,
          };
          this.applicationTokenLoading = false;
          this.verifyApplicationToken(response.token, response.audience);
        },
        error: (error) => {
          console.error('Failed to mint application token:', error);
          this.applicationTokenError = GetErrorMessageFromResponse(
            error,
            'Failed to mint application token'
          );
          this.applicationTokenLoading = false;
        },
      });
  }

  private verifyApplicationToken(token: string, audience: string) {
    this.applicationTokenVerifying = true;
    this.applicationTokenVerified = null;

    this.applicationTokenService
      .verifyToken(token, audience)
      .pipe(take(1))
      .subscribe({
        next: (verified) => {
          this.applicationTokenVerified = verified;
          this.applicationTokenVerifying = false;
        },
        error: (error) => {
          console.error('Token verification error:', error);
          this.applicationTokenVerified = false;
          this.applicationTokenVerifying = false;
        },
      });
  }
}
